import React from 'react';
import styled from 'styled-components';
import { useModal } from '../../../context/ModalContext';

function Inquire() {
  const { modalDispatch } = useModal();
  return (
    <Contianer>
      <ContentWrapper>
        <Content>
          <Title>궁금하신 점이 있으신가요?</Title>
          <CallInfoBox>
            <CallNumber>
              <img src="/assets/images/icon/call.svg" alt="" />
              02-555-2822
            </CallNumber>
            <CallTime>(평일 10:00~17:00)</CallTime>
          </CallInfoBox>
        </Content>
        <Button onClick={() => modalDispatch({ type: 'I' })}>
          <img src="/assets/images/icon/inquiry.svg" alt="" />
          문의하기
        </Button>
      </ContentWrapper>
    </Contianer>
  );
}

export default Inquire;

const Contianer = styled.div`
  width: 100%;
  padding: 24px 16px;
  background-color: #fff;
`;

const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  border-radius: 8px;
  padding: 12px 16px;
  background-color: #008aff0f;
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

const Title = styled.div`
  font-size: 14px;
  font-weight: 700;
  color: #000c1ecc;
`;

const CallInfoBox = styled.div`
  display: flex;
  flex-direction: column;
`;

const CallNumber = styled.div`
  display: flex;
  flex-direction: row;
  gap: 4px;
  align-items: center;
  font-size: 14px;
  font-weight: 500;
  color: #000c1ecc;
`;

const CallTime = styled.div`
  font-size: 12px;
  font-weight: 500;
  color: #6b7684;
`;

const Button = styled.button`
  display: flex;
  flex-direction: row;
  gap: 5px;
  border-radius: 8px;
  padding: 6px 14px;
  background: #008aff;
  border: none;
  align-items: center;
  justify-content: center;

  font-size: 14px;
  font-weight: 500;
  color: #fff;
`;
